<template>
  <div class="view_page">
    <div class="page_head"></div>
    <div class="page_body">
      <div class="content">
        <div style="width:100%;height:8%;display:flex;justify-content: center;">
          <i class="ic_check" @click="SelectUserInfo"></i>
          <input type="text" class="checked" placeholder="手机号搜索" ref="phone" />
        </div>
        <div style="width:100%;height:90%;display:flex;flex-direction: column;">
          <div
            v-for="(item,index) in statusCard"
            :key="index"
            @click="Order(index)"
            style="width:100%;height:16%;background:rgba(255,255,255,1);border-radius:16px;margin-bottom: 5%;"
          >
            <img
              src="../../../resource/img/WeChatbfaed0e8af0e4c8e8548f1f00bfb909e.png"
              alt
              class="kximg"
            />
            <div class="hxtext">
              <font
                v-if="item.nickname!=null"
                style="font-family:PingFangSC-Regular;font-weight:400;color:rgba(0,0,0,1);font-size:15.5px;"
              >
                {{item.nickname}}
                <span
                  v-if="urlParam.status==0"
                  style="float:right;color:rgba(70,70,70,1);font-size:12.5px;"
                >未使用</span>
                <span
                  v-if="urlParam.status==1"
                  style="float:right;color:rgba(70,70,70,1);font-size:12.5px;"
                >正在使用</span>
                <span v-else style="float:right;color:rgba(70,70,70,1);font-size:12.5px;">已使用</span>
              </font>
              <font v-else>没有查询到用户信息</font>
              <p style="color:rgba(143,143,143,1)" v-if="item.phone!=null">{{item.phone}}</p>
              <p style="color:rgba(143,143,143,1)" v-else>15274345261</p>
              <font style="float:right;color:rgba(143,143,143,1)">获取时间{{item.payTime}}</font>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MerUnionmbViewAlliance",
  data() {
    return {
      urlParam: {},
      statusCard: []
    };
  },
  created() {
    this.urlParam = this.$route.params;
    console.log(this.urlParam.status);
    this.LmkUserInfo();
  },
  methods: {
    LmkUserInfo: function() {
      var that = this;
      that.$axios
        .post(
          "/mer/merUnion/store/findUserInfo.do",
          that.$qs.stringify({
            activityId: that.urlParam.activityId,
            status: that.urlParam.status,
            phone: null
          })
        )
        .then(response => {
          console.log(response.data);
          that.statusCard = response.data.list;
        })
        .catch(function(error) {
          //请求失败处理
          console.log(error);
        });
    },
    SelectUserInfo: function() {
      var that = this;
      var num = this.$refs.phone.value;
      if ((num != null) & (num.length == 11) & (num == Number)) {
        that.$axios
          .post(
            "/mer/merUnion/store/findUserInfo.do",
            that.$qs.stringify({
              uid: that.urlParam.uid,
              activityId: that.urlParam.activityId,
              status: that.urlParam.status,
              phone: num
            })
          )
          .then(response => {
            console.log(response.data);
          })
          .catch(function(error) {
            //请求失败处理
            console.log(error);
          });
      } else {
        alert("请输入正确的手机号码");
      }
    },
    Order: function(index) {
      let that = this;
      that.$router.push({
        path: "/MerUnionmbHxinformation",
        name: "MerUnionmbHxinformation",
        params: {
          storeId: that.urlParam.storeId,
          activityId: that.urlParam.activityId,
          uid: that.statusCard[index].uid
        }
      });
    }
  }
};
</script>
<style scoped>
.view_page {
  width: 100%;
  height: 100%;
  margin-top: 50px;
}
.page_head {
  width: 100%;
  height: 30vh;
  background-image: url("../../../resource/img/Nipic_12106414_20160922174257880038.png");
}
.page_body {
  width: 100%;
  height: 64vh;
  background: rgba(242, 242, 242, 1);
  display: flex;
  justify-content: center;
}
.content {
  width: 92%;
  height: 80vh;
  border-radius: 20px 20px 20px 20px;
  position: relative;
  top: -35%;
  /* display: flex;*/
  /* justify-content: center; */
  /* flex-direction: column;  */
}
.checked {
  width: 61%;
  height: 4vh;
  background: rgba(255, 255, 255, 1);
  border-radius: 30px;
  border: none;
  padding-left: 7vh;
}
.ic_check {
  position: relative;
  left: 6vh;
  z-index: 5;
  background-image: url("../../../resource/img/sousuo.png"); /*引入图片图片*/
  background-repeat: no-repeat; /*设置图片不重复*/
  background-size: 40px;
  width: 50px; /*设置图片显示的宽*/
  height: 50px; /*图片显示的高*/
  margin-top: 1vh;
}
.kximg {
  width: 16%;
  height: 65%;
  padding-left: 4%;
  padding-top: 4%;
  float: left;
}
.hxtext {
  width: 70%;
  height: 100%;
  padding-left: 2%;
  padding-top: 3%;
  float: left;
}
</style>




// WEBPACK FOOTER //
// src/components/active/member/MerUnionmbViewAlliance.vue